import React from 'react';
import Providers from '../../../../components/providers';
import ColumnBlock from '../../../../components/blocks/column';

const PagebuilderMenuColumn = ({ column }) => (
  <Providers>
    <ColumnBlock
      columnWidth={12}
      column={column}
      align="start"
    />
  </Providers>
);

export default PagebuilderMenuColumn;
